export default __webpack_public_path__ + "static/media/logo.922d33a1.png";